import { useEffect, useState } from "react";
import { initRDKit } from "./utils/initRDKit";
import { RDKitModule } from "@/types/rdkit";

interface ReactionStructureProps {
    reactionString: string; // reaction string in SMILES format
    width: number;
    height: number;
}

const ReactionStructure = ({ reactionString, width, height }: ReactionStructureProps) => {  
    const [svg, setSvg] = useState<string>("");
    
    useEffect(() => {
        initRDKit().then((RDKit: RDKitModule) => {
            const reaction = RDKit.get_rxn(reactionString);
            console.log(reaction);
            const svg = reaction.get_svg_with_highlights(JSON.stringify({width, height, bondLineWidth: 0.75}));
            setSvg(svg);
        });
    }, [reactionString, width, height]);

    return <div dangerouslySetInnerHTML={{ __html: svg }} />;
};

export default ReactionStructure;